const configPopup = {
    list: {
        listLayout: 'PopupListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        filterLayout: 'PopupFilterDefaultLayout',
        listApiParamSet: {
            ip: 1
        },
        paginationType: 'pagination',
        pageRow: 10,
        deleteFunc:'deletePopup',
        deleteApiParamsSet : {},
        deleteSuccessType : 1,
        deleteFailTypes : {},
        keyName : 'e_idx',
    },
    create: {
        optionLayouts: ['PopupInputLayout'],
        subFunc: 'createPopup',
        parsingData: {
            title: 'e_subject',
            l_display: 'e_link',
            // link: 'e_url',
            country: 'c_idx',

        },
        detailApiParamSet: {
            ip: 0,
        },
        createApiParamSet: {},
        resultAlertTxt: '팝업이 등록되었습니다.',
        fileType:'event',
        directType:'list',
        directUrl: '/popup',
    },
    update: {
        optionLayouts: ['PopupInputLayout'],
        subFunc: 'updatePopup',
        parsingData: {
            title: 'e_subject',
            l_display: 'e_link',
            country: 'c_idx',
        },
        detailApiParamSet: {
            ip: 0,
        },
        createApiParamSet: {},
        resultAlertTxt: '팝업이 수정되었습니다.',
        fileType:'event',
        directType:'list',
        directUrl: '/popup',
    },
}

export default {
    methods: {
        returnPopupConfig(type) {
            return configPopup[type];
        }
    },
    filterConfig: {
        su: {
            type: 'query',
            classname: 'searchInput',
        },
        cr: {
            type: 'between',
            classname: 'filterDate',
        },
        cid: {
            type: 'match',
            classname: 'filterCountry'
        }
    }
}